export var InputVariant;
(function (InputVariant) {
    InputVariant["Underline"] = "underline";
    InputVariant["LabelIn"] = "labelIn";
    InputVariant["LabelOut"] = "labelOut";
    InputVariant["LabelOnLine"] = "labelOnLine";
})(InputVariant || (InputVariant = {}));
